import { ApiService } from './../services/api.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  gameDetails: any = [];
  urlData: any;
  menu: any = [];
  content: any = [];
  trendingList: any = [];
  topGames: any = [];
  recommendList: any = [];
  slideConfig: any;
  id: number = 0;
  lang: any;
  categoryid: number = 0;
  operator: number = 0;
  biller: any;
  theme: number = 0;
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.gameDetails = this.apiService.getItem();
    this.getMainData();
  }

  public getGameUrl(url: any) {
    window.open(url, '_blank');
  }

  gotoHome(item: any) {
    this.apiService.setItem(item);
    this.gameDetails = this.apiService.getItem();
    this.router.navigate(['/details']); // define your component where you want to go
    window.scroll(0, 0);
  }

  async getMainData() {
    this.urlData = JSON.parse(
      localStorage.getItem('globo-game-app') || 'undefined'
    );
    let data = {
      id: this.urlData.id,
      operator: this.urlData.operator,
      biller: this.urlData.biller,
      theme: this.urlData.theme
    };
    await this.apiService.getData(data).subscribe(
      (response: any) => {
        console.log('response', response);
        this.menu = response.menu;
        // this.getButtonCategories(this.menu[0].url);

        this.content = response.contentmapping;

        for (let i = 0; i < this.content.length; i++) {
          if (i < 6) {
            this.trendingList.push(this.content[i]);
          } else if (i < 10) {
            this.topGames.push(this.content[i]);
          } else if (i > 9 && i < 14) {
            this.recommendList.push(this.content[i]);
          }
        }
        console.log(this.trendingList);
        console.log(this.topGames);
        console.log(this.recommendList);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }
}
